import { useStaticQuery, graphql } from "gatsby";

export default () => {
  const data = useStaticQuery(graphql`
    {
      craft {
        entries(section: "footer", siteId: "1") {
          ... on Craft_footer_footer_Entry {
            adType {
              ... on Craft_adCategory_Category {
                adDivId
                adId
              }
            }
            footerNavigation {
              ... on Craft_footerNavigation_navigationGroup_BlockType {
                footerNavigationTitle
                footerNavigationList {
                  ... on Craft_footerNavigationList_link_BlockType {
                    text
                    href
                    openInNewTab
                    isNew
                  }
                }
              }
            }
            copyright
            footerSocialMedia {
              ... on Craft_footerSocialMedia_link_BlockType {
                icon
                href
              }
            }
          }
        }
      }
    }
  `);

  return data.craft.entries[0];
};
